import { Box, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { useEffect, useMemo, useRef } from 'react';

import { useAutoCompleteContext } from './AutoCompleteInputContext';

/**
 * For rendering selected item tags
 * @returns
 */
export const AutoCompleteInputTag = () => {
  const { selectedIds, items, removeSelectedId } = useAutoCompleteContext();
  const boxRef = useRef<HTMLDivElement>(null);

  const tagList = useMemo(() => {
    return selectedIds.map((id) => ({
      id,
      name: items?.find((item) => item.value === id)?.name ?? '',
    }));
  }, [selectedIds, items]);

  const scrollToBottom = () => {
    boxRef.current?.lastElementChild?.scrollIntoView();
  };

  useEffect(() => {
    scrollToBottom();
  }, [tagList]);

  if (!tagList.length) return null;

  const autoCompleteInputTagsTestId = 'auto-complete-input-tags';

  return (
    <Box
      ref={boxRef}
      px='2'
      py='1'
      maxH={100}
      overflow={'auto'}
      visibility={selectedIds.length ? 'visible' : 'hidden'}
      data-testid={autoCompleteInputTagsTestId}
    >
      {tagList.map(({ id, name }) => (
        <Tag size='md' background='upgrade.blue.50' key={id} mx='1' mt='1'>
          <TagLabel>{name}</TagLabel>
          <TagCloseButton onClick={() => removeSelectedId(id)} />
        </Tag>
      ))}
    </Box>
  );
};

AutoCompleteInputTag.displayName = 'AutoCompleteInputTag';
